// @flow
import { handleActions } from "redux-actions";
import {
    receivedApiToken,
    receivedIdToken,
    logout,
    updateUserSettings
} from "../actions/login.actions";
import { List } from "immutable";
import { LanguageSettings } from "../records/userSettings.record";
import Record from "../flow/Record";
import { completeUserSetupSuccess } from "../actions/userSetup.actions";
import { saveProfileSuccess } from "../actions/editProfile.actions";

export class CurrentUserSettings extends Record({
    displayName: "",
    avatarURL: "",
    languages: List(),
    loggedIn: false,
    emailNotifications: false,
    user: null,
    idToken: null,
    apiToken: null,
    id: null
}) {}

const userSettings = handleActions(
    {
        [receivedApiToken](state, { payload: { token } }) {
            return state.merge({ apiToken: token });
        },
        [receivedIdToken](state, { payload: { user, idToken } }) {
            return state.merge({ user, idToken });
        },
        [updateUserSettings](state, { payload: { user } }) {
            const { displayName, avatarURL, languages, id } = user;
            return state.merge({
                loggedIn: true,
                displayName,
                id,
                avatarURL,
                languages: List(languages.map(l => new LanguageSettings(l)))
            });
        },
        [completeUserSetupSuccess](
            state,
            {
                payload: { languages }
            }: { payload: { languages: List<LanguageSettings> } }
        ) {
            return state.merge({ languages });
        },
        [saveProfileSuccess](state, { payload }) {
            return state.merge(payload);
        },
        [logout]() {
            return new CurrentUserSettings();
        }
    },
    new CurrentUserSettings()
);

export default userSettings;



// WEBPACK FOOTER //
// ./src/reducers/userSettings.reducer.js